import { useMediaQueries } from "@react-hook/media-query";
import style from "./header.module.css";
import Image from "next/image";
import Link from "next/link";
import HamburgerMenu from "../common/hamburger-menu/hamburger_menu";
import DropLeadModal from "@/components/common/droplead-modal/droplead_modal";
import { useState } from "react";
import { Fragment } from "react";

export default function Header({
  no_nav = false,
}) {
  const [isOpenDropLeadModal, setIsOpenDropLeadModal] = useState();
  const mobile = useMediaQueries({
    screen: "screen",
    min: "(min-width: 0px)",
    max: "(max-width: 1023px)",
  });
  // const onDropLeadModalOpenHandler = () => {
  //   setIsOpenDropLeadModal(true);
  // };
  return (
    <nav className={style.header_section}>
      <div className={style.header}>
        <DropLeadModal
          isOpen={isOpenDropLeadModal}
          setIsOpen={setIsOpenDropLeadModal}
        />
        <div className={style.logo}>
          <Link href="/">
            <a>
              <Image
                src="/assets/images/tqm-logo.svg"
                alt="tqm logo"
                width={200}
                height={74}
              />
            </a>
          </Link>
        </div>
        {!no_nav && (
          <div className={style.nav_bar}>
            <ul className={style.nav}>
              <li key="products">
                <Link href="/products">
                  <a>แผนประกันบ้าน</a>
                </Link>
              </li>
              <li key="calculatePlan">
                <Link href="/calculate-plan/home-info">
                  <a>คำนวณเบี้ยประกัน</a>
                </Link>
              </li>
              <li key="article">
                <Link href="/articles">
                  <a>เรื่องบ้านน่ารู้</a>
                </Link>
              </li>
              <li key="smes">
                <Link href="/smes">
                  <a>ประกันบ้านสำหรับ SME</a>
                </Link>
              </li>
            </ul>
          </div>
        )}
        <div className={style.contact_icon}>
          <ul className={style.wrapper}>
            <li className="hidden tablet:block" key="fb">
              <Image
                src="/assets/images/social-fb-white.svg"
                alt="TQM Facebook icon"
                width={25}
                height={25}
              />
            </li>
            <li className="hidden tablet:block" key="line">
              <Image
                src="/assets/images/social-line-white.svg"
                alt="TQM LINE icon"
                width={25}
                height={25}
              />
            </li>
            <li key="icon">
              <Image
                src="/assets/images/tqm-24.svg"
                alt="TQM Contact Icon"
                width={112}
                height={40}
              />
            </li>
          </ul>
        </div>
      </div>
      {!no_nav && (
        <Fragment>
          {mobile.matchesAll && <HamburgerMenu />}
        </Fragment>
      )}
    </nav>
  );
}
